import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputSelectField from '../../Fields/InputSelectField';
import SalesLimitTable from '../../Fields/SalesLimitTable';


class RateDetailSalesPanel extends React.Component {
  _onSalesLimitChange = (ident, value) => {
    const data = _.cloneDeep(this.props.rate.fields.sales_limits.value);
    data[ident] = value;

    this._onInputChange('sales_limits')(data);
  }


  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'months_to_sell_in_advance':
          if (value !== null) value = parseInt(value, 10);
          break;
        default:
      }

      this.props.onValueChange(inputId, value);
    };
  }


  render() {
    const {
      rate,
      newMode,
      editMode,
      fieldConfiguration
    } = this.props;

    const {
      rate: rateFieldConfiguration
    } = fieldConfiguration;

    const salesLimitTableRows = rate.fields.sales_limits.value.map((salesLimit, index) => {
      return { ident: index, data: salesLimit };
    });

    const requiredFieldState = (newMode || editMode);

    return (
      <div>
        <FieldGroup label={`${rate.fields.name.value || ''} Sales Limits`}>
          <Field label="Number of months to sell in advance:"
            labelWidth="md"
            id="parkchirp--rate--months-to-sell-in-advance"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--rate--months-to-sell-in-advance"
              options={[{ value: null, label: '' }, ...rateFieldConfiguration.months_to_sell_in_advance.options]}
              value={rate.fields.months_to_sell_in_advance.value}
              onChange={this._onInputChange('months_to_sell_in_advance')}
              editMode={newMode || editMode}
            />
          </Field>
          <Field>
            <SalesLimitTable inputId="parkchirp--rate--sales-limits"
              salesLimitRows={salesLimitTableRows}
              onSalesLimitChange={this._onSalesLimitChange}
              newMode={newMode}
              editMode={newMode || editMode}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default RateDetailSalesPanel;
